import Service from "../Service";
const resource = "/ReceptionTransfer/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID },
    });
  },
  save(parameters, requestID) {
    return Service.post(resource + "save", parameters, {
      params: { requestID },
    });
  },
};
